var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.579 6.889c0 1.296.518 2.54 1.441 3.457a4.94 4.94 0 0 0 3.48 1.432 4.94 4.94 0 0 0 3.48-1.432 4.87 4.87 0 0 0 1.441-3.457c0-1.297-.518-2.54-1.441-3.457A4.94 4.94 0 0 0 12.5 2a4.94 4.94 0 0 0-3.48 1.432A4.87 4.87 0 0 0 7.58 6.889M12.5 13.111a8.54 8.54 0 0 0-6.008 2.476A8.43 8.43 0 0 0 4 21.556a.443.443 0 0 0 .447.444h16.106a.45.45 0 0 0 .447-.444 8.43 8.43 0 0 0-2.492-5.969 8.54 8.54 0 0 0-6.008-2.476"
  })));
};
export default SvgUser;